import React from 'react'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import _lowerCase from 'lodash/lowerCase'
import _startCase from 'lodash/startCase'

const styles = () => ({
  title: {
    fontWeight: 'bold',
  },
})

function InfoText(props) {
  const {
    classes,
    label,
    placeholder,
    value,
    handleOnChange,
  } = props

  return (
    <Box mb={3}>
      <Box mb={1}>
        <Typography className={classes.title} variant="h6">{_startCase(_lowerCase(label))}</Typography>
      </Box>
      <TextField
        InputProps={{
          startAdornment: <InputAdornment position="start">UID</InputAdornment>,
        }}
        fullWidth
        variant="outlined"
        placeholder={placeholder}
        value={value}
        onChange={(e) => handleOnChange(e)}
      />
    </Box>
  )
}

InfoText.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  handleOnChange: PropTypes.func.isRequired,
}

InfoText.defaultProps = {
  value: '',
}

export default withStyles(styles)(InfoText)
